import { render, staticRenderFns } from "./CreateAnnouncements.vue?vue&type=template&id=56b304d7&"
import script from "./CreateAnnouncements.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports